const FormContentBlockerLayout = {
    labelCol: {
        span: 6
    },
    wrapperCol: {
        span: 16
    }
};
const FormServiceLayout = {
    labelCol: {
        span: 6
    },
    wrapperCol: {
        span: 16
    }
};
const FormLayoutTcfVendor = {
    labelCol: {
        span: 6
    },
    wrapperCol: {
        span: 16
    }
};
export { FormContentBlockerLayout, FormLayoutTcfVendor, FormServiceLayout };
